import React from 'react';
import { Card, Button, Spinner } from 'react-bootstrap';
import { func, bool, arrayOf } from 'prop-types';

import { smartFromFieldType } from 'components/SmartForm/types';

import SmartForm from '../SmartForm';

import './Login.sass';

function Login({ fields, handleSubmit, isLoading }) {
  const refToFormik = React.useRef(null);

  const submitOnEnter = (e) => {
    if (e.keyCode === 13) {
      refToFormik.current.submitForm();
    }
  };
  return isLoading ? (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spinner animation="border" />
    </div>
  ) : (
    <Card className="app-login">
      <Card.Header className="text-center">
        <Card.Title>Login</Card.Title>
      </Card.Header>
      <Card.Body onKeyDown={submitOnEnter}>
        <SmartForm
          className="login-smart-form"
          ref={refToFormik}
          fields={fields}
          handleSubmit={handleSubmit}
        />
        <div className="d-flex">
          <Button
            variant="primary"
            active={isLoading}
            onClick={() => refToFormik.current.submitForm()}
          >
            Login
          </Button>
          <Button variant="link" className="ml-auto">
            <a
              href="https://epos.erply.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Sign up
            </a>
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}

Login.propTypes = {
  fields: arrayOf(smartFromFieldType).isRequired,
  handleSubmit: func.isRequired,
  isLoading: bool,
};

export default Login;
